import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { InterviewDataService } from './services/interview-data.service';
import { SharedReviewerService } from '../../shared-reviewer.service';
import { Subject } from 'rxjs';

declare var window: any;
@Component({
    selector: 'reviewer',
    templateUrl: './reviewer.component.html',
    standalone: false
})
export class ReviewerComponent implements OnInit {

    form: UntypedFormGroup;
    editFeedback: any = true;
    current: any;
    question: any;
    currentFeedback: any = [];
    currentIndex: number = 0;
    rating: any;
    token: any;

    private modal: any;
    private _feedback: Subject<object> = new Subject();

    @ViewChild('response', {static:false}) responseComponent: any;

    constructor(
        private fb: UntypedFormBuilder,
        private _activatedRoute: ActivatedRoute,
        private _dataService: InterviewDataService,
        private _reviewerService: SharedReviewerService
    ) {}

    get feedback() {
        return this._feedback.asObservable();
    }

    ngOnInit() {
        this.createForm();
        this._activatedRoute.parent.params.subscribe((params) => {
            this._dataService.interviewId = params['id'] || this._activatedRoute.parent.snapshot.queryParamMap.get('interview_id');
            this._dataService.attemptId = this._activatedRoute.parent.snapshot.queryParamMap.get('attempt_id');
            this.token = window.parent.REVIEWER_TOKEN;
            this._reviewerService.feedback.subscribe((fb) => {
                if (fb) {
                    this.loadFeedback(fb);
                    this.continueToNextQuestion(fb);
                }
            });
            this.playCurrentAttempt();
        });
    }

    createForm() {
        this.form = this.fb.group({
            review: [''],
            ratings: [this.rating]
        });
    }

    setCurrentFeedback() {
        this._reviewerService.feedback.subscribe((fb) => {
            if (fb) {
                this.loadFeedback(fb);
            }
        });

    }

    loadFeedback(feedback) {
        this.currentFeedback = feedback[0] || null;
        this.rating = this.currentFeedback ? this.currentFeedback.rating : '0';
        this.form.controls['review'].setValue(this.currentFeedback ? this.currentFeedback.review : '');
        if (this.rating !== '0' || this.form.controls['review'].value) {
            this.editFeedback = false;
        }  else {
            this.editFeedback = true;
        }
    }

    continueToNextQuestion(fb) {
        this.editFeedback = false;
        if (this.question === this.current.questions[this.current.questions.length - 1]) {
            let modal = this._reviewerService.openReviewerModal('send-external-feedback', this.current, window.parent.LOGGED_IN, true);
            modal.result.then((res) => {
                if (res) {
                    this._reviewerService.sendFeedbackNotification(this._dataService.attemptId, true);
                } else {
                    this.editFeedback = true;
                }
            })
        }
        this.playCurrentAttempt();
        this.responseComponent.nextQuestion();
    }

    playCurrentAttempt(id:any = this._dataService.attemptId){
        this._dataService.getAttempt(id, this.token);
        this._dataService.attempt
            .subscribe((resp:any) => {
                if (resp) {
                    this.current = resp[0];
                }
            });
    }

    currentQuestion(question) {
        this.question = question;
        if (this.question.feedback.length) {
            if (this.rating || this.form.controls['review'].value) {
                this.editFeedback = false;
            }
        }
        this.loadFeedback(this.question['feedback']);
    }

    onClick(rating: any): void {
        this.rating = rating;
        this.form.controls['ratings'].setValue(this.rating);
    }

    clearRating() {
        this.rating = 0;
    }

    addFeedback() {
        let data = Object.create(null);
        data.review = this.form.value.review;
        data.rating = this.rating;
        data.video_interview_question_wrapper_id = this.question.question_wrapper_id;
        if (this.currentFeedback) {
            if (this.currentFeedback['video_interview_feedback_id'])
            data.video_interview_feedback_id = this.currentFeedback['video_interview_feedback_id'];
        }

        this._reviewerService.saveFeedback(this._dataService.attemptId, data, true);
    }

    editCurrentFeedback() {
        this.editFeedback = true;
        this.rating = this.currentFeedback.rating;
        this.form.controls['review'].setValue(this.currentFeedback.review);
    }
}

